<template>
  <div class="text-center" :class="pulse ? 'pulse-container' : ''">
    <div v-if="pulse" class="loading">
      <div class="spinner" />
    </div>

    <pb-icon
      v-else
      class="fas fa-spinner fa-spin fa-fw"
      :class="[`fa-${spinnerSize}`]"
    />

    <p v-show="text" class="pb">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'ProLoading',
  props: {
    text: { type: String, default: 'Carregando...' },
    pulse: { type: Boolean, default: false },
    spinnerSize: { type: String, default: '2x' },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.pulse-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading {
  width: 6rem;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  .spinner {
    border-radius: 50%;
    border: 11px solid black;
    animation: 1.5s pulse infinite ease-in-out;
  }
  @keyframes pulse {
    0% {
      width: 0;
      height: 0;
      opacity: 0;
    }
    50% {
      border-width: 3px;
    }
    60%{
      opacity: 1;
    }
    90% {
      opacity: 0;
    }
    100% {
      width: 5rem;
      height: 5rem;
      border-width: 0;
      opacity: 0;
    }
  }
}
</style>
